/* global define:true */
/* jslint browser: true, devel: true*/
define(['jquery', 'BaseView'],

function ($, BaseView) {

	'use strict';

	return BaseView.extend({
		initialize: function () {
			var input = document.createElement('input'),
				nativeClear = (window.getComputedStyle && window.getComputedStyle(input, ':-ms-clear').content) ? true : false;

			// only enable for touch devices, do not enable on IE>10 where -ms-clear is used
			if ($('body').data('iswireless') && !nativeClear) {
				this.delegateEvents({
					'keyup .textInput input': 'showClearButton',
					'change .textInput input': 'showClearButton',
					'focus .textInput input': 'showClearButton',
					'blur .textInput input': 'hideClearButton',
					'mousedown .clearInput': 'clearInput',
					'touchstart .clearInput': 'clearInput'
				});
			}
		},

		showClearButton: function (event) {
			var $input = $(event.currentTarget);

			if ($input.val()) {
				this.$('.clearInput[data-clear="' + $input.attr('id') + '"]').removeClass('hide');
			}

			if ($input.parent().hasClass('hasError')) {
				this.$('.clearInput').addClass('hasError');
			}

			if (event.keyCode === 8 && !$input.val()) {
				this.hideClearButton(event);
			}
		},

		hideClearButton: function (event) {
			this.$('.clearInput[data-clear="' + event.currentTarget.id + '"]').addClass('hide').removeClass('hasError');
		},

		clearInput: function (event) {
			var $input = $('#' + $(event.currentTarget).data('clear'));

			$input.val('');
			this.hideClearButton(event);

			setTimeout(function() {
				$input.focus();
			}, 10);
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./widgets/clearInput.js
// module id = 49
// module chunks = 0